import React from "react";
import { ArrowUpRight, Github } from "lucide-react";
import { useT } from "../context/LanguageContext";

const KufibotSection = () => {
  const t = useT();

  return (
    <section
      aria-labelledby="kufibot-title"
      className="py-16 lg:py-24 px-6"
      style={{ background: "var(--section-surface-4)", color: "var(--fg)" }}
    >
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div
          className="rounded-3xl p-6 lg:p-8"
          style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}
        >
          <img
            src="/images/pages/kufibot.png"
            alt={t("kufibot.imageAlt")}
            width="1122"
            height="1402"
            loading="lazy"
            decoding="async"
            className="w-full h-auto max-h-[480px] object-contain"
          />
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest mb-4" style={{ color: "var(--brand-cyan)" }}>
            ROS 2 · Verasist API & SDK
          </p>
          <h2 id="kufibot-title" className="font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl">
            {t("kufibot.title")}
          </h2>
          <p className="mt-5 text-base leading-relaxed max-w-xl opacity-90">
            {t("kufibot.description")}
          </p>
          <a
            href="https://github.com/electronicengine/kufibot.ros2"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-7 inline-flex items-center gap-3 rounded-full px-6 py-3 text-sm font-semibold transition-opacity hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4"
            style={{ background: "var(--fg)", color: "var(--bg)" }}
          >
            <Github size={18} aria-hidden="true" />
            {t("kufibot.github")}
            <ArrowUpRight size={16} aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default KufibotSection;
